import type { SanityRefTypes } from './SanityRefsUtil';

export default class ExtractedRef {
  private _type: SanityRefTypes;

  private key: string;

  private _id: string;

  constructor({ _type, _id }: { _type: SanityRefTypes; _id: string }) {
    this._type = _type;
    this.key = `${_type}-${_id}`;
    this._id = _id;
  }

  getType(): SanityRefTypes {
    return this._type;
  }

  getKey(): string {
    return this.key;
  }

  getId(): string {
    return this._id;
  }

  static getKeyFromTypeAndId({ _type, _id }: { _type: SanityRefTypes; _id: string }): string {
    return `${_type}-${_id}`;
  }
}
